const ranking = [
  {
    rank: 1,
    title: '暗夜追影',
    type: '电影',
    tag: '动作悬疑',
    heat: '本周播放量TOP1',
    trend: 'hot',
  },
  {
    rank: 2,
    title: '星河恋人',
    type: '电视剧',
    tag: '都市爱情',
    heat: '连续3周上榜',
    trend: 'up',
  },
  {
    rank: 3,
    title: '星辰变',
    type: '动漫',
    tag: '修仙奇幻',
    heat: '新番人气第一',
    trend: 'up',
  },
  {
    rank: 4,
    title: '笑傲江湖',
    type: '综艺',
    tag: '喜剧竞演',
    heat: '口碑持续飙升',
    trend: 'hot',
  },
  {
    rank: 5,
    title: '地球脉动III',
    type: '纪录片',
    tag: '自然生态',
    heat: '高分推荐',
    trend: 'stable',
  },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-white';
    if (rank === 2) return 'bg-primary-300 text-white';
    if (rank === 3) return 'bg-accent-400 text-white';
    return 'bg-secondary-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            本周最受欢迎的热门内容排行
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl border border-secondary-100 overflow-hidden">
            {ranking.map((r, i) => (
              <div
                key={r.rank}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  i < ranking.length - 1 ? 'border-b border-secondary-100' : ''
                } hover:bg-background-50 transition-colors cursor-pointer`}
              >
                <div
                  className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${getRankStyle(r.rank)}`}
                >
                  {r.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">{r.title}</h3>
                    <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">{r.type}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{r.tag}</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    {r.trend === 'hot' && <i className="ri-fire-line text-red-500"></i>}
                    {r.trend === 'up' && <i className="ri-arrow-up-line text-accent-500"></i>}
                    {r.trend === 'stable' && <i className="ri-subtract-line text-foreground-300"></i>}
                    {r.heat}
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <i className="ri-play-circle-line text-foreground-300 text-xl hover:text-primary-500 transition-colors cursor-pointer"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}